<template>
  <div class="equipment">
    <div class="topinfo">
      <div class="ellist">
        <div
          class="item"
          v-for="(item, index) in elList"
          :key="index"
          :class="index === elIndex ? 'active' : ''"
          @click="elIndex = index"
        >
          {{ item }}
        </div>
      </div>
      <div class="monitor-list">
        <div
          class="item"
          :class="index == monitorIndex ? 'active' : ''"
          v-for="(item, index) in monitorList"
          :key="index"
          @click="monitorIndex = index"
        >
          <div>{{ item.value }}</div>
        </div>
      </div>
    </div>
    <div class="out-main">
      <div class="e-main">
        <div class="setUp">
          <div class="left">
            <span>显示 </span>
            <el-select v-model="optionsvalue" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span> 项结果</span>
          </div>
          <div class="right">
            <el-input v-model="input" placeholder="请输入内容"></el-input>
            <el-button type="primary">搜索</el-button>
            <div class="io disable">开启所选项</div>
            <div class="io disable close">关闭所选项</div>
          </div>
        </div>
        <div class="total">
          <span>设备总数：</span>
          <span>212</span>
        </div>
        <div class="table-box">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="35"> </el-table-column>
            <el-table-column prop="name" label="序号"> </el-table-column>
            <el-table-column prop="name" label="配电室"> </el-table-column>
            <el-table-column prop="name" label="配电柜编号"> </el-table-column>
            <el-table-column prop="name" label="回路名称"> </el-table-column>
            <el-table-column prop="name" label="设备位置"> </el-table-column>
            <el-table-column prop="name" label="设备类型"> </el-table-column>
            <el-table-column prop="name" label="投入使用时间">
            </el-table-column>
            <el-table-column prop="name" label="设备型号"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="img-box">
                  <img
                    src="../assets/images/operation1.png"
                    @click="handle1(scope.row)"
                  />
                  <img src="../assets/images/operation2.png" />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="报警设置">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.isOpen"
                  active-color="rgba(20, 96, 224, 1)"
                  inactive-color="rgba(182, 182, 182, 1)"
                >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="info">
          <div class="left">第 2 页（共108页），显示1至10项结果，共1,006项</div>
          <div class="right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage4"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="400"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      elList: ["总配电室", "1#配电室", "2#配电室"],
      elIndex: 0,
      monitorIndex: 0,
      monitorList: [
        {
          value: "高压仪表",
        },
        {
          value: "低压仪表",
        },
        {
          value: "继电保护",
        },
        {
          value: "变压器温控",
        },
        {
          value: "温湿度设备",
        },
        {
          value: "水浸设备",
        },
      ],
      options: [
        {
          value: "1",
          label: "10",
        },
        {
          value: "2",
          label: "15",
        },
        {
          value: "3",
          label: "20",
        },
      ],
      optionsvalue: "1",
      input: "",
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          isOpen: true,
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-08",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-06",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-07",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
      multipleSelection: [],
      currentPage4: 4,
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="less" scoped>
.equipment {
  .topinfo {
    background: #fff;
    padding: 20px;
    padding-bottom: 0px;
    width: calc(100% - 40px);
    box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
    .ellist {
      display: flex;
      margin-top: 22px;
      .item {
        width: 106px;
        height: 32px;
        margin-right: 20px;
        background: #eeeeee;
        border-radius: 5px;
        text-align: center;
        font-size: 12px;
        color: #8e9fa8;
        line-height: 32px;
        cursor: pointer;
        &.active {
          color: #fff;
          background: #1460e0;
        }
      }
    }
    .monitor-list {
      display: flex;
      margin-top: 16px;
      .item {
        display: flex;
        > div {
          padding: 8px 22px;
          color: #0e223d;
          font-size: 16px;
          cursor: pointer;
          padding-bottom: 10px;
        }
        &.active {
          > div {
            font-weight: 600;
            border-bottom: 3px solid #1460e0;
          }
        }
      }
    }
  }
  .out-main {
    padding: 15px;
    box-sizing: border-box;
  }
  .e-main {
    background: #f8f8f9;
    padding: 20px;
    box-sizing: border-box;
    .setUp {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        .el-select {
          width: 120px;
          margin: 0 10px;
        }
        span {
          font-size: 16px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .el-input {
          width: 200px;
          margin-right: 20px;
        }
        .el-button {
          margin-right: 20px;
        }
        .io {
          width: 144px;
          height: 40px;
          background: #e6efff;
          border: 1px solid rgba(20, 96, 224, 0.5);
          border-radius: 5px;
          text-align: center;
          line-height: 40px;
          font-size: 18px;
          color: rgba(20, 96, 224, 1);
          cursor: pointer;
          margin-right: 20px;
          &.close {
            color: rgba(239, 157, 76, 1);
            border: 1px solid rgba(239, 157, 76, 0.5);
            background: rgba(255, 243, 230, 1);
          }
          &.disable {
            color: #c0c4cc;
            border: 1px solid #dcdfe6;
            background-color: #f4f4f5;
          }
        }
      }
    }
    .total {
      margin-top: 20px;
      span {
        font-size: 16px;
        &:last-of-type {
          font-weight: 600;
        }
      }
    }
    .table-box {
      margin-top: 15px;
      /deep/.el-table {
        background: rgba(0, 0, 0, 0);
        th,
        tr {
          background: rgba(0, 0, 0, 0);
        }
        thead {
          background: #f5f5f5 !important;
        }
        th {
          > .cell {
            color: #152139;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
          }
        }
        tr {
          td {
            text-align: center;
            font-size: 14px;
            color: #152139;
          }
        }
        .img-box {
          img {
            width: 24px;
            margin: 0 5px;
          }
        }
      }
    }
    .info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .left {
        font-size: 12px;
        color: rgba(137, 146, 159, 1);
      }
    }
  }
}
</style>